module.exports = __webpack_public_path__ + "img/img (51).e837b1c1.jpg";